import { useRecommendedPlanName } from "@next-platform/client-common-core/infra/application/capabilities";
import { Button, ButtonSize, ButtonVariant, IconVariants, Modal, ModalSize, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { PlanLinks } from "@/components";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";
import { ROUTES } from "@/constants";

import { UpgradeToPremiumModalProps } from "./types";

const TEXT_COLOR = "text-gray-12";

function UpgradeToPremiumModal(props: UpgradeToPremiumModalProps) {
  const { isOpen, onClose, title, paywallRoles } = props;
  const planNames = useRecommendedPlanName(paywallRoles ?? []);

  return (
    <Modal
      title={title}
      className="dark:!bg-gray-6 gap-md"
      size={ModalSize.LARGE}
      open={isOpen}
      onOpenChange={onClose}
      loading={false}
      data-testid="UpgradeToPremiumModal"
    >
      <Text variant={TextVariants.LABEL_LARGE_REGULAR} className={TEXT_COLOR}>
        {planNames.length ? (
          <>
            <Trans i18nKey="chat:modal.tryAIAutoSelect.upgradePlan.description" /> <PlanLinks planNames={planNames} />
            <Trans i18nKey="chat:modal.upgradePlan.plans" />
          </>
        ) : null}
      </Text>
      <LocalizedLink to={ROUTES.subscribe}>
        <Button
          iconStart={IconVariants.CROWN}
          size={ButtonSize.LARGE}
          variant={ButtonVariant.TRANSPARENT}
          className="w-full gap-lg bg-gradient-to-r from-purple-9 to-blue-9 text-white"
        >
          <Trans i18nKey="common:upgradeNow" />
        </Button>
      </LocalizedLink>
    </Modal>
  );
}

export default UpgradeToPremiumModal;
